import { useTranslation } from 'react-i18next'
import { SwitchField } from '../../rapid-ui'
import { logger } from '../../utilities'

type KeyImageAreaProps = {
	value: boolean
	brandDefault: boolean | null
	onChange: (generateKeyImage: boolean) => void
}

export function KeyImageArea({ value, brandDefault, onChange }: KeyImageAreaProps) {
	const { t } = useTranslation('common')

	const isChangedFromBrand = brandDefault !== null && value !== brandDefault

	const status = isChangedFromBrand
		? t(brandDefault ? 'editor.details.keyImageChangedFromBrandOn' : 'editor.details.keyImageChangedFromBrandOff')
		: t(value ? 'editor.details.keyImageFollowsBrandOn' : 'editor.details.keyImageFollowsBrandOff')

	const handleToggle = (generateKeyImage: boolean) => {
		onChange(generateKeyImage)
		logger.track('Editor: AI image choice changed', {
			data: {
				generate_key_image: generateKeyImage ? 'yes' : 'no',
				matches_brand_default: generateKeyImage === brandDefault ? 'yes' : 'no',
			},
		})
	}

	const handleReset = (brandGenerateKeyImage: boolean) => {
		onChange(brandGenerateKeyImage)
		logger.track('Editor: AI image choice reset', {
			data: { generate_key_image: brandGenerateKeyImage ? 'yes' : 'no' },
		})
	}

	return (
		<div className="flex flex-col gap-2 mt-8">
			<div className="text-lg font-medium">{t('editor.details.keyImage')}</div>
			<SwitchField
				checked={value}
				onChange={handleToggle}
				label={t('editor.details.generateKeyImage')}
				description={status}
			>
				{isChangedFromBrand && (
					<button
						type="button"
						className="mt-1 text-xs font-medium text-brand-600 hover:underline"
						onClick={() => handleReset(brandDefault)}
					>
						{t('editor.details.keyImageResetToBrand')}
					</button>
				)}
			</SwitchField>
		</div>
	)
}
